// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Edit Exercise Dialog — theme-aware (bright + dark) */

.eed-dialog.MuiDialog-paper {
  --eed-bg: var(--bg-color, #f5f8fa);
  --eed-surface: var(--surface-color, #ffffff);
  --eed-text: var(--text-color, #1a2b3c);
  --eed-muted: var(--text-secondary, #78909c);
  --eed-border: var(--border-color, #e8eef3);
  --eed-soft: color-mix(in srgb, var(--eed-text) 4%, var(--eed-surface));
  --eed-hover: color-mix(in srgb, var(--eed-text) 6%, var(--eed-surface));
  --eed-shadow: 0 2px 10px var(--shadow-color, rgba(8, 119, 188, 0.08));
  margin: 0;
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  border-radius: 0;
  background: var(--eed-bg);
  color: var(--eed-text);
  color-scheme: light dark;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dark-mode .eed-dialog.MuiDialog-paper,
.eed-dialog.dark-mode.MuiDialog-paper,
html[data-theme="dark"] .eed-dialog.MuiDialog-paper {
  --eed-bg: var(--bg-color, #0f172a);
  --eed-surface: var(--surface-color, #111827);
  --eed-text: var(--text-color, #f9fafb);
  --eed-muted: var(--text-secondary, #9ca3af);
  --eed-border: rgba(255, 255, 255, 0.12);
  --eed-soft: rgba(255, 255, 255, 0.05);
  --eed-hover: rgba(255, 255, 255, 0.08);
  --eed-shadow: 0 2px 14px rgba(0, 0, 0, 0.35);
}

.light-mode .eed-dialog.MuiDialog-paper,
.eed-dialog.light-mode.MuiDialog-paper,
html[data-theme="light"] .eed-dialog.MuiDialog-paper {
  --eed-bg: var(--bg-color, #f5f8fa);
  --eed-surface: var(--surface-color, #ffffff);
  --eed-text: var(--text-color, #1a2b3c);
  --eed-muted: var(--text-secondary, #78909c);
  --eed-border: var(--border-color, #e8eef3);
}

.eed-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: max(12px, env(safe-area-inset-top, 0px)) 16px 12px;
  background: var(--eed-surface);
  border-bottom: 1px solid var(--eed-border);
  flex-shrink: 0;
  color: var(--eed-text);
}

.eed-header__text {
  min-width: 0;
  flex: 1 1;
}

.eed-header__eyebrow {
  margin: 0 0 2px;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
}

.eed-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 750;
  letter-spacing: -0.02em;
  color: var(--eed-text);
  line-height: 1.25;
}

.eed-header__mode {
  display: inline-flex;
  margin-top: 6px;
  padding: 3px 9px;
  border-radius: 8px;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--eed-surface));
  color: var(--brand-primary, #0877bc);
  font-size: 11px;
  font-weight: 700;
}

.eed-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 12px 12px 20px;
  color: var(--eed-text);
}

.eed-hero {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  margin-bottom: 12px;
  background: var(--eed-surface);
  border-radius: 16px;
  border: 1px solid var(--eed-border);
  box-shadow: var(--eed-shadow);
}

.eed-hero__top {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.eed-hero__img {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  overflow: hidden;
  background: var(--eed-soft);
  display: flex;
  align-items: center;
  justify-content: center;
}

.eed-hero__img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.eed-hero__info {
  flex: 1 1;
  min-width: 0;
}

.eed-hero__name {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 750;
  color: var(--eed-text);
  line-height: 1.3;
  word-break: break-word;
}

.eed-hero__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.eed-tag {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 700;
}

.eed-tag--type {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 14%, var(--eed-surface));
  color: var(--brand-primary, #0877bc);
}

.eed-tag--subtype {
  background: color-mix(in srgb, var(--brand-secondary, #2e7d32) 16%, var(--eed-surface));
  color: color-mix(in srgb, var(--brand-secondary, #2e7d32) 82%, var(--eed-text));
  border: 1px solid color-mix(in srgb, var(--brand-secondary, #2e7d32) 40%, transparent);
}

.eed-exchange-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 46px;
  padding: 10px 14px;
  border: 1.5px solid color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--eed-border));
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--eed-surface)),
    var(--eed-surface)
  );
  color: var(--brand-primary, #0877bc);
  font: inherit;
  font-size: 14px;
  font-weight: 750;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.eed-exchange-btn:hover {
  box-shadow: 0 4px 14px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
}

.eed-exchange-btn:active {
  transform: scale(0.98);
}

.eed-exchange-btn:disabled {
  opacity: 0.55;
  cursor: default;
  box-shadow: none;
}

.eed-section {
  margin-bottom: 12px;
  padding: 14px;
  background: var(--eed-surface);
  border-radius: 16px;
  border: 1px solid var(--eed-border);
  box-shadow: var(--eed-shadow);
}

.eed-section__title {
  margin: 0 0 12px;
  font-size: 12px;
  font-weight: 750;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--eed-muted);
}

.eed-section__row {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.eed-same-skill {
  margin-top: 4px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--eed-soft);
  border: 1px solid var(--eed-border);
}

.eed-same-skill__label {
  display: block;
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 700;
  color: var(--eed-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.eed-same-skill__group {
  margin-bottom: 8px;
}

.eed-same-skill__group:last-child {
  margin-bottom: 0;
}

.eed-same-skill__type {
  margin: 0 0 4px;
  font-size: 13px;
  font-weight: 700;
  color: var(--eed-text);
}

.eed-same-skill__list {
  margin: 0;
  padding-left: 18px;
  color: var(--eed-muted);
  font-size: 13px;
}

.eed-seq-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 12px;
}

.eed-seq-empty {
  margin: 0 0 12px;
  padding: 14px;
  border-radius: 12px;
  border: 1px dashed var(--eed-border);
  background: var(--eed-soft);
  color: var(--eed-muted);
  font-size: 0.85rem;
  font-weight: 600;
  text-align: center;
}

.eed-seq-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.eed-seq-head__title {
  margin: 0;
  font-size: 12px;
  font-weight: 750;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--eed-muted);
}

.eed-seq-head__remain {
  font-size: 12px;
  font-weight: 700;
  color: var(--eed-muted);
}

.eed-seq-head__remain--ok {
  color: #2e7d32;
}

.eed-seq-head__remain--over {
  color: #c62828;
}

.dark-mode .eed-seq-head__remain--ok,
html[data-theme="dark"] .eed-seq-head__remain--ok {
  color: #81c784;
}

.dark-mode .eed-seq-head__remain--over,
html[data-theme="dark"] .eed-seq-head__remain--over {
  color: #ef9a9a;
}

.eed-seq {
  margin-bottom: 10px;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid var(--eed-border);
  background: var(--eed-soft);
  color: var(--eed-text);
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  touch-action: pan-y;
}

.eed-seq:last-child {
  margin-bottom: 0;
}

.eed-seq--dragging {
  border-color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 14%, var(--eed-surface));
  box-shadow: 0 6px 16px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
  transform: scale(1.01);
  cursor: grabbing;
  touch-action: none;
}

.eed-seq--over {
  border-style: dashed;
  border-color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--eed-surface));
}

.eed-seq--dimmed {
  opacity: 0.5;
}

.eed-seq__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.eed-seq__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: var(--brand-primary, #0877bc);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.eed-seq__label {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 650;
  color: var(--eed-text);
}

.eed-seq__fields {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.eed-seq__roles {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.eed-seq__duration-label,
.eed-seq__duration-hint {
  color: var(--eed-muted);
}

.eed-footer {
  display: flex;
  gap: 8px;
  padding: 12px 16px max(12px, env(safe-area-inset-bottom, 0px));
  background: var(--eed-surface);
  border-top: 1px solid var(--eed-border);
  flex-shrink: 0;
}

.eed-footer__btn {
  flex: 1 1;
  min-height: 46px;
  border-radius: 12px !important;
  font-weight: 750 !important;
  text-transform: none !important;
}

/* MUI fields inside dialog follow theme surfaces */
.eed-dialog .MuiInputBase-root,
.eed-dialog .MuiOutlinedInput-root {
  background: var(--eed-soft);
  color: var(--eed-text);
}

.eed-dialog .MuiInputLabel-root,
.eed-dialog .MuiFormHelperText-root {
  color: var(--eed-muted);
}

.eed-dialog .MuiOutlinedInput-notchedOutline {
  border-color: var(--eed-border);
}

.eed-dialog .MuiSvgIcon-root {
  color: inherit;
}

@media (min-width: 600px) {
  .eed-dialog.MuiDialog-paper {
    margin: 24px auto;
    width: min(720px, calc(100vw - 48px));
    max-width: 720px;
    height: auto;
    max-height: min(90vh, 900px);
    border-radius: 20px;
  }

  .eed-header {
    padding: 18px 22px 14px;
    border-radius: 20px 20px 0 0;
  }

  .eed-header__title {
    font-size: 22px;
  }

  .eed-body {
    padding: 16px 20px 24px;
  }

  .eed-hero {
    flex-direction: row;
    align-items: center;
  }

  .eed-hero__top {
    flex: 1 1;
    min-width: 0;
  }

  .eed-exchange-btn {
    width: auto;
    flex-shrink: 0;
    min-width: 200px;
  }

  .eed-section__row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  .eed-section__row--duration {
    grid-template-columns: 1fr;
  }

  .eed-seq__roles {
    grid-template-columns: 1fr 1fr;
  }

  .eed-footer {
    padding: 14px 22px 18px;
    border-radius: 0 0 20px 20px;
  }

  .eed-footer__btn {
    flex: 0 0 auto;
    min-width: 120px;
  }

  .eed-footer__btn--primary {
    min-width: 140px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/planning/EditExerciseDialog.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,sCAAsC;EACtC,2CAA2C;EAC3C,0CAA0C;EAC1C,sEAAsE;EACtE,uEAAuE;EACvE,qEAAqE;EACrE,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;EAGE,kCAAkC;EAClC,4CAA4C;EAC5C,sCAAsC;EACtC,2CAA2C;EAC3C,uCAAuC;EACvC,qCAAqC;EACrC,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;;;EAGE,kCAAkC;EAClC,4CAA4C;EAC5C,sCAAsC;EACtC,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,2DAA2D;EAC3D,8BAA8B;EAC9B,0CAA0C;EAC1C,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qFAAqF;EACrF,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qFAAqF;EACrF,oCAAoC;AACtC;;AAEA;EACE,uFAAuF;EACvF,+EAA+E;EAC/E,sFAAsF;AACxF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,4FAA4F;EAC5F,mBAAmB;EACnB;;;;GAIC;EACD,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,2BAA2B;EAC3B,sBAAsB;EACtB,gFAAgF;EAChF,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,qFAAqF;EACrF,yFAAyF;EACzF,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,oFAAoF;AACtF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,8DAA8D;EAC9D,8BAA8B;EAC9B,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,8BAA8B;EAC9B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,mDAAmD;AACnD;;EAEE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Edit Exercise Dialog — theme-aware (bright + dark) */\n\n.eed-dialog.MuiDialog-paper {\n  --eed-bg: var(--bg-color, #f5f8fa);\n  --eed-surface: var(--surface-color, #ffffff);\n  --eed-text: var(--text-color, #1a2b3c);\n  --eed-muted: var(--text-secondary, #78909c);\n  --eed-border: var(--border-color, #e8eef3);\n  --eed-soft: color-mix(in srgb, var(--eed-text) 4%, var(--eed-surface));\n  --eed-hover: color-mix(in srgb, var(--eed-text) 6%, var(--eed-surface));\n  --eed-shadow: 0 2px 10px var(--shadow-color, rgba(8, 119, 188, 0.08));\n  margin: 0;\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  max-height: 100%;\n  border-radius: 0;\n  background: var(--eed-bg);\n  color: var(--eed-text);\n  color-scheme: light dark;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.dark-mode .eed-dialog.MuiDialog-paper,\n.eed-dialog.dark-mode.MuiDialog-paper,\nhtml[data-theme=\"dark\"] .eed-dialog.MuiDialog-paper {\n  --eed-bg: var(--bg-color, #0f172a);\n  --eed-surface: var(--surface-color, #111827);\n  --eed-text: var(--text-color, #f9fafb);\n  --eed-muted: var(--text-secondary, #9ca3af);\n  --eed-border: rgba(255, 255, 255, 0.12);\n  --eed-soft: rgba(255, 255, 255, 0.05);\n  --eed-hover: rgba(255, 255, 255, 0.08);\n  --eed-shadow: 0 2px 14px rgba(0, 0, 0, 0.35);\n}\n\n.light-mode .eed-dialog.MuiDialog-paper,\n.eed-dialog.light-mode.MuiDialog-paper,\nhtml[data-theme=\"light\"] .eed-dialog.MuiDialog-paper {\n  --eed-bg: var(--bg-color, #f5f8fa);\n  --eed-surface: var(--surface-color, #ffffff);\n  --eed-text: var(--text-color, #1a2b3c);\n  --eed-muted: var(--text-secondary, #78909c);\n  --eed-border: var(--border-color, #e8eef3);\n}\n\n.eed-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: max(12px, env(safe-area-inset-top, 0px)) 16px 12px;\n  background: var(--eed-surface);\n  border-bottom: 1px solid var(--eed-border);\n  flex-shrink: 0;\n  color: var(--eed-text);\n}\n\n.eed-header__text {\n  min-width: 0;\n  flex: 1;\n}\n\n.eed-header__eyebrow {\n  margin: 0 0 2px;\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n}\n\n.eed-header__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n  color: var(--eed-text);\n  line-height: 1.25;\n}\n\n.eed-header__mode {\n  display: inline-flex;\n  margin-top: 6px;\n  padding: 3px 9px;\n  border-radius: 8px;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--eed-surface));\n  color: var(--brand-primary, #0877bc);\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.eed-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 12px 12px 20px;\n  color: var(--eed-text);\n}\n\n.eed-hero {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 14px;\n  margin-bottom: 12px;\n  background: var(--eed-surface);\n  border-radius: 16px;\n  border: 1px solid var(--eed-border);\n  box-shadow: var(--eed-shadow);\n}\n\n.eed-hero__top {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.eed-hero__img {\n  flex-shrink: 0;\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--eed-soft);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.eed-hero__img img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.eed-hero__info {\n  flex: 1;\n  min-width: 0;\n}\n\n.eed-hero__name {\n  margin: 0 0 6px;\n  font-size: 16px;\n  font-weight: 750;\n  color: var(--eed-text);\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.eed-hero__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.eed-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 8px;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.eed-tag--type {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 14%, var(--eed-surface));\n  color: var(--brand-primary, #0877bc);\n}\n\n.eed-tag--subtype {\n  background: color-mix(in srgb, var(--brand-secondary, #2e7d32) 16%, var(--eed-surface));\n  color: color-mix(in srgb, var(--brand-secondary, #2e7d32) 82%, var(--eed-text));\n  border: 1px solid color-mix(in srgb, var(--brand-secondary, #2e7d32) 40%, transparent);\n}\n\n.eed-exchange-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  min-height: 46px;\n  padding: 10px 14px;\n  border: 1.5px solid color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--eed-border));\n  border-radius: 12px;\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--eed-surface)),\n    var(--eed-surface)\n  );\n  color: var(--brand-primary, #0877bc);\n  font: inherit;\n  font-size: 14px;\n  font-weight: 750;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.eed-exchange-btn:hover {\n  box-shadow: 0 4px 14px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n}\n\n.eed-exchange-btn:active {\n  transform: scale(0.98);\n}\n\n.eed-exchange-btn:disabled {\n  opacity: 0.55;\n  cursor: default;\n  box-shadow: none;\n}\n\n.eed-section {\n  margin-bottom: 12px;\n  padding: 14px;\n  background: var(--eed-surface);\n  border-radius: 16px;\n  border: 1px solid var(--eed-border);\n  box-shadow: var(--eed-shadow);\n}\n\n.eed-section__title {\n  margin: 0 0 12px;\n  font-size: 12px;\n  font-weight: 750;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--eed-muted);\n}\n\n.eed-section__row {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.eed-same-skill {\n  margin-top: 4px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: var(--eed-soft);\n  border: 1px solid var(--eed-border);\n}\n\n.eed-same-skill__label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--eed-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.eed-same-skill__group {\n  margin-bottom: 8px;\n}\n\n.eed-same-skill__group:last-child {\n  margin-bottom: 0;\n}\n\n.eed-same-skill__type {\n  margin: 0 0 4px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--eed-text);\n}\n\n.eed-same-skill__list {\n  margin: 0;\n  padding-left: 18px;\n  color: var(--eed-muted);\n  font-size: 13px;\n}\n\n.eed-seq-presets {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0 0 12px;\n}\n\n.eed-seq-empty {\n  margin: 0 0 12px;\n  padding: 14px;\n  border-radius: 12px;\n  border: 1px dashed var(--eed-border);\n  background: var(--eed-soft);\n  color: var(--eed-muted);\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.eed-seq-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.eed-seq-head__title {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 750;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--eed-muted);\n}\n\n.eed-seq-head__remain {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--eed-muted);\n}\n\n.eed-seq-head__remain--ok {\n  color: #2e7d32;\n}\n\n.eed-seq-head__remain--over {\n  color: #c62828;\n}\n\n.dark-mode .eed-seq-head__remain--ok,\nhtml[data-theme=\"dark\"] .eed-seq-head__remain--ok {\n  color: #81c784;\n}\n\n.dark-mode .eed-seq-head__remain--over,\nhtml[data-theme=\"dark\"] .eed-seq-head__remain--over {\n  color: #ef9a9a;\n}\n\n.eed-seq {\n  margin-bottom: 10px;\n  padding: 12px;\n  border-radius: 14px;\n  border: 1px solid var(--eed-border);\n  background: var(--eed-soft);\n  color: var(--eed-text);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\n  cursor: grab;\n  user-select: none;\n  touch-action: pan-y;\n}\n\n.eed-seq:last-child {\n  margin-bottom: 0;\n}\n\n.eed-seq--dragging {\n  border-color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 14%, var(--eed-surface));\n  box-shadow: 0 6px 16px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n  transform: scale(1.01);\n  cursor: grabbing;\n  touch-action: none;\n}\n\n.eed-seq--over {\n  border-style: dashed;\n  border-color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--eed-surface));\n}\n\n.eed-seq--dimmed {\n  opacity: 0.5;\n}\n\n.eed-seq__header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.eed-seq__num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.eed-seq__label {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 650;\n  color: var(--eed-text);\n}\n\n.eed-seq__fields {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.eed-seq__roles {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n}\n\n.eed-seq__duration-label,\n.eed-seq__duration-hint {\n  color: var(--eed-muted);\n}\n\n.eed-footer {\n  display: flex;\n  gap: 8px;\n  padding: 12px 16px max(12px, env(safe-area-inset-bottom, 0px));\n  background: var(--eed-surface);\n  border-top: 1px solid var(--eed-border);\n  flex-shrink: 0;\n}\n\n.eed-footer__btn {\n  flex: 1;\n  min-height: 46px;\n  border-radius: 12px !important;\n  font-weight: 750 !important;\n  text-transform: none !important;\n}\n\n/* MUI fields inside dialog follow theme surfaces */\n.eed-dialog .MuiInputBase-root,\n.eed-dialog .MuiOutlinedInput-root {\n  background: var(--eed-soft);\n  color: var(--eed-text);\n}\n\n.eed-dialog .MuiInputLabel-root,\n.eed-dialog .MuiFormHelperText-root {\n  color: var(--eed-muted);\n}\n\n.eed-dialog .MuiOutlinedInput-notchedOutline {\n  border-color: var(--eed-border);\n}\n\n.eed-dialog .MuiSvgIcon-root {\n  color: inherit;\n}\n\n@media (min-width: 600px) {\n  .eed-dialog.MuiDialog-paper {\n    margin: 24px auto;\n    width: min(720px, calc(100vw - 48px));\n    max-width: 720px;\n    height: auto;\n    max-height: min(90vh, 900px);\n    border-radius: 20px;\n  }\n\n  .eed-header {\n    padding: 18px 22px 14px;\n    border-radius: 20px 20px 0 0;\n  }\n\n  .eed-header__title {\n    font-size: 22px;\n  }\n\n  .eed-body {\n    padding: 16px 20px 24px;\n  }\n\n  .eed-hero {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .eed-hero__top {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .eed-exchange-btn {\n    width: auto;\n    flex-shrink: 0;\n    min-width: 200px;\n  }\n\n  .eed-section__row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n  }\n\n  .eed-section__row--duration {\n    grid-template-columns: 1fr;\n  }\n\n  .eed-seq__roles {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .eed-footer {\n    padding: 14px 22px 18px;\n    border-radius: 0 0 20px 20px;\n  }\n\n  .eed-footer__btn {\n    flex: 0 0 auto;\n    min-width: 120px;\n  }\n\n  .eed-footer__btn--primary {\n    min-width: 140px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
